// @flow
import * as React from 'react';

import { connect } from 'react-redux';
import { compose } from 'redux';

import { withLogger } from 'gandi.redux-logger';

import type { FullState } from 'src/types';

import { selectCurrentContactForProcessAndRole } from '../../../modules/selectors';

import { getInitialValues } from '../helpers';

import Presenter from './Presenter';
import type { StateProps, OwnProps } from './Presenter';

const mapStateToProps = (
  state: FullState,
  { process, role, canWriteContactBook, owner }: OwnProps,
): StateProps => {
  const contact =
    selectCurrentContactForProcessAndRole(state, {
      process,
      role,
    }) || owner;

  const initialValues = getInitialValues(canWriteContactBook, contact);

  return {
    initialValues,
  };
};

const EditContact: React.ComponentType<OwnProps> = compose(
  connect(mapStateToProps),
  withLogger('ModifyDomainContact/EditContact'),
)(Presenter);

EditContact.displayName = 'EditContact';

export default EditContact;
